export const tabs = [
  {
    id: 'tripsData',
    href: '/security',
    title: 'Список рейсів на завантаження',
  },
  {
    id: 'unloadTripsData',
    href: '/security/unload',
    title: 'Список рейсів на розвантаження',
  },
  {
    id: 'reportsData',
    href: '/security/reports',
    title: 'Звіти',
  },
];
